
import { Component } from '@angular/core';
import { ToastController, NavController, AlertController, NavParams } from 'ionic-angular';
import { Validators, FormBuilder, FormGroup, FormControl } from '@angular/forms';

import { BusinessUserProvider } from '../../providers/business-user';

@Component({
  selector: 'page-business-user-management',
  templateUrl: 'business-user-management.html',
})
export class BusinessUserManagementPage {
	form : FormGroup;
	formChangePassword : FormGroup;
	formManageActivity : FormGroup;

	isWorking: boolean = false;
	isWorkingActivity: boolean = false;
	isWorkingChangePassword: boolean = false;
	currentUser: any;

	recievedError: any;
	errorText: any;

	constructor(
		private toastCtrl: ToastController,
		public alertCtrl: AlertController,
		public navCtrl: NavController, 
		public navParams: NavParams,
		public formBuilder: FormBuilder,
		public businessUserProvider: BusinessUserProvider,		
	) {
		this.currentUser = navParams.get('user');

		if(!this.currentUser){
			this.currentUser = {Id:0};
		}

		this.configForm();

	   	if(this.currentUser.Id != ''){
	    	this.form.patchValue(
	    		this.currentUser
	    	);
	    }		
	}

	configForm(){
		if(this.currentUser.Id==0){
			this.form = this.formBuilder.group({
				"Id": [0],
				"FullName":  ['', Validators.compose([Validators.required, Validators.minLength(5)]) ],			
			  	"Email":  ['', Validators.compose([Validators.required, Validators.email])],
			  	"Password":  ['', Validators.compose([Validators.required, Validators.minLength(6)]) ],  
			  	"RoleId": ['dbc550d7-6976-4385-878f-f26578ae06f3'],
			  	"IsActive": [true],
			  	"IsBlocked": [false],
			});		
		}else{
			if(!this.form){
				this.form = this.formBuilder.group({
					"Id": [0],
					"FullName":  ['', Validators.compose([Validators.required, Validators.minLength(5)]) ],			
				  	"Email":  ['', Validators.compose([Validators.required, Validators.email])],				  	
				  	"RoleId": ['dbc550d7-6976-4385-878f-f26578ae06f3'],
				  	"IsActive": [true],
				  	"IsBlocked": [false],
				});					
			}

			this.form.setControl(
				"Password", new FormControl('')
	        );	

			this.formChangePassword = this.formBuilder.group({
				"Id":  [this.currentUser.Id],  
			  	"Password":  ['', Validators.compose([Validators.required, Validators.minLength(6)]) ],  
			});		    

			this.formManageActivity = this.formBuilder.group({
				"Id":  [this.currentUser.Id],  
			  	"IsActive": [this.currentUser.IsActive],
			  	"IsBlocked": [this.currentUser.IsBlocked],
			});		
		}
	}

	ionViewDidLoad() {
		console.log('ionViewDidLoad BusinessUserManagementPage');
	}

	save(){
		this.isWorking = true;

		let isUpdate = (this.form.value.Id>0? true : false);

		this.businessUserProvider.save({
			cb: (resp)=>{
				this.isWorking = false;		

				if(resp.Message){
					this.recievedError = true;
					this.errorText = resp.Message;
				}else{
					this.recievedError = false;
					this.errorText = "";

					if(!isUpdate){
						this.currentUser = resp.Data;

						this.configForm();

						this.form.patchValue(
							this.currentUser
						);
					}

					let toast = this.toastCtrl.create({
						message: 'User saved',
						duration: 3000,
						position: 'bottom'
					});

					toast.present();						
				}

			
			},
			data: this.form.value
		});		
	}

	saveActivity(){
		this.isWorkingActivity = true;

		this.businessUserProvider.udpateUserActivity({
			cb: (resp)=>{
				this.isWorkingActivity = false;		

				if(resp.Message!="" && resp.Message!=null){
			    	this.formManageActivity.patchValue(
			    		{"IsActive": false}
			    	);

					let alert = this.alertCtrl.create({
						title: 'Activate user',
						subTitle: resp.Message,
						buttons: ['Dismiss']
					});

					alert.present();		
				}else{
					let toast = this.toastCtrl.create({
						message: 'User activity saved',
						duration: 3000,
						position: 'bottom'
					});

					toast.present();							
				}		
			},
			data: this.formManageActivity.value
		});				
	}

	changePassowrd(){
		this.isWorkingChangePassword = true;

		this.businessUserProvider.changePassword({
			cb: (resp)=>{
				this.isWorkingChangePassword = false;		

				let toast = this.toastCtrl.create({
					message: 'Password changed',
					duration: 3000,
					position: 'bottom'
				});

				toast.present();		

				this.formChangePassword.reset();

		    	this.formChangePassword.patchValue(
		    		{Id: this.currentUser.Id}
		    	);	 
			},
			data: {
				Id: this.formChangePassword.value.Id,
				Password: this.formChangePassword.value.Password
			}
		});				
	}

	//(ionBlur)="onBlurInput()" (ionFocus)="onFocusInput()"

	// ionViewWillLeave(){
	// 	this.keyboard.disableScroll(true);
	// }

	// onFocusInput(){
	// 	this.keyboard.disableScroll(false);
	// }

	// onBlurInput(){
	// 	this.keyboard.disableScroll(true);
	// }	
}



// WEBPACK FOOTER //
// ./src/pages/business-user-management/business-user-management.ts